<button
  class="control"
  tabindex="-1"
  [hidden]="!isOverflowed()"
  (click)="previousFilters()"
>
  <i class="control__left icon icon-chevron-left"></i>
</button>

<ul #list class="filters">
  @if (isLoading()) {
    @for (i of [0, 1, 2, 3, 4,5,6,7,8,9]; track $index) {
      <app-skeleton-loader height="24px" />
    }
  } @else {
    @for (filter of filters(); track $index) {
      <li class="filters__item filter">
        <button
          #filterButton
          class="filter__button"
          [attr.data-id]="filter.id"
          [innerHTML]="filter.name"
          [ngClass]="[isActive(filter.id) ? 'active' : 'inactive']"
          (click)="onFilterClick(filter.id)"
        ></button>
      </li>
    }
  }
</ul>

<button
  class="control"
  tabindex="-1"
  [hidden]="!isOverflowed()"
  (click)="nextFilters()"
>
  <i class="control__right icon icon-chevron-right"></i>
</button>
